import { Button } from '../../components/Button';
import { ContentParser } from '../../components/ContentParser';
import { Modal } from '../../components/Modal';
import { CloseIcon } from '../../icons/CloseIcon';
import {
  Body,
  CloseButton,
  Content,
  CtaContainer,
  Heading,
  Image,
  ValidFor,
  Wrapper,
} from './AnnouncementDialog.styles';
import type { AnnouncementDialogProps } from './AnnouncementDialog.types';

export function AnnouncementDialog({
  open,
  onClose,
  heading,
  body,
  imageUrl,
  validFor,
  cta,
  closeLabel = 'Close',
}: AnnouncementDialogProps) {
  return (
    <Modal open={open} onClose={onClose} ariaLabel={heading} aboveMobileNav>
      <Wrapper>
        <CloseButton type="button" onClick={onClose} aria-label={closeLabel}>
          <CloseIcon size={10} />
        </CloseButton>
        {imageUrl && <Image src={imageUrl} alt="" />}
        <Content>
          <Heading>{heading}</Heading>
          {validFor && <ValidFor>{validFor}</ValidFor>}
          <Body>
            <ContentParser text={body} />
          </Body>
        </Content>
        {cta && (
          <CtaContainer>
            <Button variant="primary" fullWidth onClick={cta.onClick}>
              {cta.label}
            </Button>
          </CtaContainer>
        )}
      </Wrapper>
    </Modal>
  );
}
